// @flow

// $FlowFixMe
import {
  // $FlowFixMe
  useState,
  // $FlowFixMe
  useEffect,
  // $FlowFixMe
  useRef
} from "react";
import { attempt, isError } from "lodash";
import type { UnaryFn } from "@tvg/types/Functional";

const buildSubscription = (
  variables: mixed,
  document: *,
  subscribeToMore: UnaryFn<mixed, void>
) => {
  const [hasSubscription, setSubscription] = useState(false);

  useEffect(() => {
    if (!hasSubscription && subscribeToMore) {
      attempt(() => {
        subscribeToMore({ document, variables });
        setSubscription(true);
      });
    }
  }, [subscribeToMore]);
};

export const useFocus = () => {
  const htmlElRef = useRef(null);

  const setFocus = () => {
    if (htmlElRef.current) {
      htmlElRef.current.focus();
    }
  };

  return [htmlElRef, setFocus];
};

export const useParseCapiMessage = (message: string) => {
  const [parsedMessage, setParsedMessage] = useState("");

  useEffect(() => {
    const messageParsed = attempt((json) => JSON.parse(json), message);

    if (!isError(messageParsed)) {
      setParsedMessage(messageParsed);
    }
  }, [message]);

  return parsedMessage;
};

// custom hook for getting previous value
export const usePrevious = (value: any) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export default buildSubscription;

export function useInterval(callback: any, delay: number | null) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    let id;
    if (id) {
      clearInterval(id);
    }

    function tick() {
      if (savedCallback.current) {
        savedCallback.current();
      }
    }
    if (delay !== null) {
      id = setInterval(tick, delay);
      return () => clearInterval(id);
    }

    return false;
  }, [delay]);
}
